/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteTask200Response } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FootprintUpdateRequest } from '../models';
// @ts-ignore
import type { TravelPlan } from '../models';
/**
 * TravelApi - axios parameter creator
 * @export
 */
export const TravelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get high-speed rail routes dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHSRRoutes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/hsr-routes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get 5A scenic spots dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenic5A: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/scenic-5a`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tour guide dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourGuide: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/tour-guide`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get travel categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get travel footprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelFootprint: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/footprint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get travel plan detail (raw JSON)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelPlan: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTravelPlan', 'id', id)
            const localVarPath = `/api/travel/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all travel plans
         * @param {string} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTravelPlans: async (category?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/travel/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update visitors of a footprint destination
         * @param {string} destID 
         * @param {FootprintUpdateRequest} footprintUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTravelFootprint: async (destID: string, footprintUpdateRequest: FootprintUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destID' is not null or undefined
            assertParamExists('updateTravelFootprint', 'destID', destID)
            // verify required parameter 'footprintUpdateRequest' is not null or undefined
            assertParamExists('updateTravelFootprint', 'footprintUpdateRequest', footprintUpdateRequest)
            const localVarPath = `/api/life/travel/footprint/{destID}`
                .replace(`{${"destID"}}`, encodeURIComponent(String(destID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(footprintUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TravelApi - functional programming interface
 * @export
 */
export const TravelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TravelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get high-speed rail routes dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHSRRoutes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHSRRoutes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getHSRRoutes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get 5A scenic spots dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScenic5A(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScenic5A(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getScenic5A']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get tour guide dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTourGuide(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTourGuide(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getTourGuide']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get travel categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTravelCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTravelCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getTravelCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get travel footprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTravelFootprint(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTravelFootprint(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getTravelFootprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get travel plan detail (raw JSON)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTravelPlan(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTravelPlan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.getTravelPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all travel plans
         * @param {string} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTravelPlans(category?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TravelPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTravelPlans(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.listTravelPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update visitors of a footprint destination
         * @param {string} destID 
         * @param {FootprintUpdateRequest} footprintUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTravelFootprint(destID: string, footprintUpdateRequest: FootprintUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTask200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTravelFootprint(destID, footprintUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TravelApi.updateTravelFootprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TravelApi - factory interface
 * @export
 */
export const TravelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TravelApiFp(configuration)
    return {
        /**
         * 
         * @summary Get high-speed rail routes dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHSRRoutes(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getHSRRoutes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get 5A scenic spots dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenic5A(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getScenic5A(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tour guide dataset (raw JSON passthrough)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourGuide(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTourGuide(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get travel categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelCategories(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTravelCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get travel footprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelFootprint(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTravelFootprint(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get travel plan detail (raw JSON)
         * @param {TravelApiGetTravelPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelPlan(requestParameters: TravelApiGetTravelPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTravelPlan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all travel plans
         * @param {TravelApiListTravelPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTravelPlans(requestParameters: TravelApiListTravelPlansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TravelPlan>> {
            return localVarFp.listTravelPlans(requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update visitors of a footprint destination
         * @param {TravelApiUpdateTravelFootprintRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTravelFootprint(requestParameters: TravelApiUpdateTravelFootprintRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTask200Response> {
            return localVarFp.updateTravelFootprint(requestParameters.destID, requestParameters.footprintUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TravelApi - interface
 * @export
 * @interface TravelApi
 */
export interface TravelApiInterface {
    /**
     * 
     * @summary Get high-speed rail routes dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getHSRRoutes(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get 5A scenic spots dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getScenic5A(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get tour guide dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getTourGuide(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get travel categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getTravelCategories(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get travel footprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getTravelFootprint(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get travel plan detail (raw JSON)
     * @param {TravelApiGetTravelPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    getTravelPlan(requestParameters: TravelApiGetTravelPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List all travel plans
     * @param {TravelApiListTravelPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    listTravelPlans(requestParameters?: TravelApiListTravelPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TravelPlan>>;

    /**
     * 
     * @summary Update visitors of a footprint destination
     * @param {TravelApiUpdateTravelFootprintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApiInterface
     */
    updateTravelFootprint(requestParameters: TravelApiUpdateTravelFootprintRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTask200Response>;

}

/**
 * Request parameters for getTravelPlan operation in TravelApi.
 * @export
 * @interface TravelApiGetTravelPlanRequest
 */
export interface TravelApiGetTravelPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof TravelApiGetTravelPlan
     */
    readonly id: string
}

/**
 * Request parameters for listTravelPlans operation in TravelApi.
 * @export
 * @interface TravelApiListTravelPlansRequest
 */
export interface TravelApiListTravelPlansRequest {
    /**
     * 
     * @type {string}
     * @memberof TravelApiListTravelPlans
     */
    readonly category?: string
}

/**
 * Request parameters for updateTravelFootprint operation in TravelApi.
 * @export
 * @interface TravelApiUpdateTravelFootprintRequest
 */
export interface TravelApiUpdateTravelFootprintRequest {
    /**
     * 
     * @type {string}
     * @memberof TravelApiUpdateTravelFootprint
     */
    readonly destID: string

    /**
     * 
     * @type {FootprintUpdateRequest}
     * @memberof TravelApiUpdateTravelFootprint
     */
    readonly footprintUpdateRequest: FootprintUpdateRequest
}

/**
 * TravelApi - object-oriented interface
 * @export
 * @class TravelApi
 * @extends {BaseAPI}
 */
export class TravelApi extends BaseAPI implements TravelApiInterface {
    /**
     * 
     * @summary Get high-speed rail routes dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getHSRRoutes(options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getHSRRoutes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get 5A scenic spots dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getScenic5A(options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getScenic5A(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tour guide dataset (raw JSON passthrough)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getTourGuide(options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getTourGuide(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get travel categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getTravelCategories(options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getTravelCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get travel footprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getTravelFootprint(options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getTravelFootprint(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get travel plan detail (raw JSON)
     * @param {TravelApiGetTravelPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public getTravelPlan(requestParameters: TravelApiGetTravelPlanRequest, options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).getTravelPlan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all travel plans
     * @param {TravelApiListTravelPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public listTravelPlans(requestParameters: TravelApiListTravelPlansRequest = {}, options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).listTravelPlans(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update visitors of a footprint destination
     * @param {TravelApiUpdateTravelFootprintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelApi
     */
    public updateTravelFootprint(requestParameters: TravelApiUpdateTravelFootprintRequest, options?: RawAxiosRequestConfig) {
        return TravelApiFp(this.configuration).updateTravelFootprint(requestParameters.destID, requestParameters.footprintUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

